import client from '../utils/client';
import { descriptionsUrl } from '../store/constants/api';
import { cookieConstants } from "../store/constants";
import { Cookies } from "react-cookie";

const cookies = new Cookies();

export const descriptionService = {
  descriptionsList,
  addDescription,
  getDescription,
  updateDescription
}

function descriptionsList(pageID, perPage) {
  return client.get(descriptionsUrl + '?page=' + pageID + '&per_page=' + perPage)
    .then((response) => {
      return response
    })
    .catch(handleResponse);
}

function addDescription(formDate) {
  return client.post(descriptionsUrl + '/create', formDate)
    .then((response) => {
      return response
    })
    .catch(handleResponse);
}

function getDescription(descriptionID) {
  return client.get(descriptionsUrl + '/' + descriptionID + '/show')
    .then((response) => {
      return response
    })
    .catch(handleResponse);
}

function updateDescription(formDate) {
  return client.post(descriptionsUrl + '/update', formDate)
    .then((response) => {
      return response
    })
    .catch(handleResponse);
}

function logout() {
  cookies.remove(cookieConstants.TOKEN, { path: "/" });
  cookies.remove(cookieConstants.USER, { path: "/" });
}

function handleResponse(response) {
  response = response.response
  var data = response.data;
  if (!response.ok) {
    if (response.status === 401) {
      logout();
      window.location.reload(true);
    }
    const error = data.errors;
    return Promise.reject(error);
  }

  return data;
}